/**
 * 工具函数
 */

/**
 * 解析轨迹点字符串为对象数组
 * @param {Array<string>} rawTraceList - 原始轨迹点字符串数组
 * @returns {Array<Object>} 解析后的轨迹点数组
 */
export const parseTracePoints = (rawTraceList) => {
    return rawTraceList.map((pointStr, pointIndex) => {
        const parts = pointStr.split(':');
        return {
            lon: Number(parts[0]),
            lat: Number(parts[1]),
            spd: parts[2],
            gpsTime: parts[3],
            gtm: parts[4], // 关键字段：与参考代码一致
            acc: Number(parts[5]),
            utc: parts[6] || '',
            angle: parts[7] || '',
            roadLimitSpd: Number(parts[8]) || 0,
            type: parts[9] || '', // 关键字段：参考代码用于判断gpsStatus
            pointIndex: pointIndex,
            // 与参考代码d函数完全一致的gpsStatus判断逻辑
            gpsStatus: parts[9] === '2' || parts[9] === '1' ? 2 : 1
        };
    });
};

/**
 * 格式化毫秒数为"时:分:秒"
 * @param {Number} ms - 毫秒数
 * @returns {string} 格式化后的时间
 */
export const formatTime = (ms) => {
    if (isNaN(ms) || ms < 0) return '00:00:00';

    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const pad = (num) => num.toString().padStart(2, '0');
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
};

/**
 * 获取GPS状态配置
 * @param {string} status - 状态值
 * @returns {Object} 状态配置
 */
export const getGpsStatusConfig = (status) => {
    const configMap = {
        '1': { className: 'clusterMarker1', str: '行驶' },
        '2': { className: 'clusterMarker2', str: '静止' },
        '3': { className: 'clusterMarker3', str: '离线' }
    };
    return configMap[status] || configMap['1'];
};